<template>
  <div class="button-group text-sm" v-auto-animate>
    <button :class="{ 'active': item.active, 'max-md:!hidden': !isToday && !item.active }" @click="useUpdateQuery({ ...item.query })" v-for="item in items.slice(0, 10)" :key="item.id">
      {{ item.name }}
    </button>
  </div>
</template>

<script async setup>
import eventSchedule from '~/data/event-schedule.js'

const dayjs = useDayjs()
const route = useRoute()

// Check active period
const isToday = computed(() => !route.query?.date && !route.query?.endDate && !route.query?.endDate)

// Set active state for navigation
const items = computed(() => eventSchedule
  .filter(item => dayjs().isSameOrBefore(item.endDate, 'day'))
  .filter(item => dayjs(item.startDate).diff(dayjs(), 'days') < item.daysInAdvance)
  .map(item => ({ 
    name: item.name,
    ...item,
    leading: item.startDate === item.endDate
      ? item.startDate
      : [item.startDate, item.endDate].join(' - '),
    active: (item.startDate === item.endDate
      ? route.query?.date === item.startDate
      : route.query?.startDate === item.startDate && route.query?.endDate === item.endDate),
    query: {
      date: (item.startDate === item.endDate) ? item.startDate : undefined,
      startDate: (item.startDate !== item.endDate) ? item.startDate : undefined,
      endDate: (item.startDate !== item.endDate) ? item.endDate : undefined,
    }
  }))
)
</script>